import { Modal } from "react-bootstrap";
import styled from "styled-components";
import { colors } from "../../../../../../../theme/theme";

export const ModalAddProductStyled = styled(Modal)`
    color: ${colors.greyscale.darker_grey};
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 140%; /* 19.6px */

    .modal-title{
        color: ${colors.greyscale.black};
        font-weight: 700;
    }

    label{
        color: #515151;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 170%; /* 23.8px */
    }

    .description{
        color: ${colors.greyscale.darker_grey};
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 100%; /* 14px */
    }

    .p-multiselect-panel .p-multiselect-items .p-multiselect-item span{
        width: 100%;
    }
`

export const DeadLineAlert = styled.div`
    border-radius: 4px;
    background: #FFE9D6;
    padding: 10px 0px;
    
    color: var(--warning-orange-41, #B65C12);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 140%;
`


export const MaterialConfirmList = styled.div`
    max-height: 150px;
    overflow: auto;
`

export const MaterialConfirmItem = styled.div`
    border-bottom: 1px solid ${colors.greyscale.light_grey};
    padding: 15px;
   

    .title{
        word-break: break-all;
        white-space: normal;
        margin: auto;
    }

    .deadline{
        text-align: center;
    }

    .price{
        text-align: center;
        margin: auto;
    }
`